const customHeaders = {
  'X-Client-Key': process.env.REACT_APP_SEKAWAN_KEY,
  'X-Client-Secret': process.env.REACT_APP_SEKAWAN_SECRET,
  'Authorization': 'Basic ' + btoa(process.env.REACT_APP_SEKAWAN_KEY + ':' + process.env.REACT_APP_SEKAWAN_SECRET),
}
export default customHeaders
